/** Grymwyrd — polska kopija wspólnego layoutu (TopNav + Footer). */
export const layoutPl = {
  'layout.nav.veil': 'Zasłona',
  'layout.nav.encyclopedia': 'Encyklopedia',
  'layout.nav.world': 'Świat',
  'layout.nav.play': 'Gra',
  'layout.nav.books': 'Księgi & Zasady',
  'layout.nav.community': 'Społeczność',
  'layout.nav.homeAria': 'Strona główna — {world}',
  'layout.nav.search': 'Przeszukaj encyklopedię',
  'layout.nav.unmute': 'Włącz ambientę',
  'layout.nav.mute': 'Wyłącz ambientę',
  'layout.nav.coinBalance': 'Stan monet',
  'layout.nav.signedInAs': 'Zalogowany jako {name}',
  'layout.nav.enter': 'Wejdź do {world}',
  'layout.nav.toggleMenu': 'Przełącz menu',
  'layout.nav.dashboard': 'Mój {world} ({name})',
  'layout.nav.signOut': 'Wyloguj się',

  'layout.footer.hideLinks': 'Ukryj linki witryny',
  'layout.footer.showLinks': 'Linki witryny i kwestie prawne',
  'layout.footer.tagline': 'Żywy świat grozy i fantazji, gdzie Twoja legenda staje się kanonem.',
  'layout.footer.explore': 'Eksploruj',
  'layout.footer.legal': 'Prawo',
  'layout.footer.accessibility': 'Dostępność',
  'layout.footer.encyclopedia': 'Encyklopedia',
  'layout.footer.world': 'Świat',
  'layout.footer.playVtt': 'Gra (VTT)',
  'layout.footer.books': 'Księgi & Zasady',
  'layout.footer.terms': 'Warunki Usługi',
  'layout.footer.privacy': 'Polityka Prywatności',
  'layout.footer.canonRelease': 'Zgoda na Publikację w Kanonie',
  'layout.footer.aiPolicy': 'Polityka AI',
  'layout.footer.cookies': 'Preferencje Plików Cookie',
  'layout.footer.copyright': '© 2026 GameCodex',
}
